// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"526":"4a1bc584","722":"4a1bc584","826":"6e047c69"}[chunkId] + ".chunk.css";
};